import { EventEmitter, Injectable } from '@angular/core';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';
import { ModuleManagerExportFormat } from 'src/shared/models/module-manager/module-manager-options.model';
import { CalculatedMetricsBreakdownData } from './calculated-metric-breakdown.model';

@Injectable({
  providedIn: 'root'
})
export class CalculatedMetricBreakdownService {

  private static readonly API_PATH = "/api/v2/dashboards/modules/calculated-metric-breakdown";

  formulaDataEvent: EventEmitter<CalculatedMetricsBreakdownData> = new EventEmitter<CalculatedMetricsBreakdownData>();

  constructor(
    private cvApiService: CVApiService,
  ) { }

  /**
 * Loads the module data for the Interval Module.
 *
 * @param moduleKey Module Key of Interval Module data to load
 * @param isAutoRefresh For logging: boolean indicating if the refresh was automatic or based on user behavior
 * @param isFirstLoad For logging: boolean indicating if this is the first time the module is loading data
 * @param cancellerPromise Optional promise that cancels the data fetch when resolved.
 */

  async fetchExportData(moduleKey: string, format: ModuleManagerExportFormat) {
    const moduleRenderUrl = await this.cvApiService.getModuleRenderEndPoint(moduleKey);
    return await this.cvApiService.get<string>(`/api/v2/dashboards/modules/calculatedMetricBreakdown/${moduleKey}/export?format=${format}`, moduleRenderUrl);
  }

  async fetchModuleData(moduleKey: string, isAutoRefresh = false, isFirstLoad = false, abort?: Promise<void>): Promise<CalculatedMetricsBreakdownData> {
    try {
      let renderEndpoint = await this.cvApiService.getModuleRenderEndPoint(moduleKey);
      let response = await this.cvApiService.get<CalculatedMetricsBreakdownData>(`/api/v2/dashboards/modules/calculatedMetricBreakdown/${moduleKey}?isAutoRefresh=${isAutoRefresh}&isFirstLoad=${isFirstLoad}`, renderEndpoint, abort);
      if (response.status_code >= 200 && response.status_code < 300){
        this.formulaDataEvent.emit(response.data);
        return response.data;
      }
      else throw response;
    } catch (err) {
      console.error("Failed getting data for Calculated Metric Breakdown module.");
      throw err;
    }
  }
}
